module.exports = __webpack_public_path__ + "r-v3/img/setting_line_gray.5b7ac500.svg";